import { useQuery } from 'react-query';

import type { ProceduralTimelineEventSuggestion } from '../../../../backend/src/matter/procedural-timeline/procedural-timeline-event-suggestion.entity';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetProceduralTimelineSuggestions = (matterId?: string, options?: { enabled?: boolean }) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<ProceduralTimelineEventSuggestion[], Error>(
    [QueryEntity.ProceduralTimelineSuggestions, { matterId }],
    async () => {
      const res = await fetch(
        `${APIBaseChronos}/api/matter/${matterId}/procedural-timeline/suggestions`,
        fetchConfigGET,
      );
      if (!res.ok) throw new Error('Failed to fetch procedural timeline suggestions');
      return res.json();
    },
    { enabled: !!matterId && (options?.enabled ?? true), refetchOnWindowFocus: false },
  );
};
